import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e210cda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-h5 text-center" }
const _hoisted_2 = { class: "d-flex flex-column flex-sm-row justify-space-between mt-4 with-gap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: $options.showDialog,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($options.showDialog) = $event)),
    width: "450"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "pa-4" }, {
        default: _withCtx(() => [
          _createElementVNode("h1", _hoisted_1, _toDisplayString($props.title), 1),
          _createVNode(_component_v_form, {
            class: "mt-2",
            onSubmit: _withModifiers($options.submitData, ["prevent"]),
            "validate-on": "blur",
            ref: "form"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "dataFields", {}, undefined, true),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_v_btn, {
                  variant: "outlined",
                  color: "red",
                  onClick: $options.closeModal
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('commonUI.dialog.closeBtn')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _renderSlot(_ctx.$slots, "mainAction", {}, undefined, true)
              ])
            ]),
            _: 3
          }, 8, ["onSubmit"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["modelValue"]))
}